import { LocalizationProvider } from "@mui/x-date-pickers";
import AppRoutes from "./Pages/AppRoutes";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Toaster } from "react-hot-toast";
import "dayjs/locale/ar";
function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ar">
      <Toaster />
      <AppRoutes />
    </LocalizationProvider>
  );
}

export default App;
